<template>
  <v-container>
    <v-row class="text-center">
      <v-col cols="12">
        <v-parallax dark src="../assets/background.png">
          <v-row align="center" justify="center">
            <sparkline></sparkline>
            <v-col class="text-center" cols="12">
              <h1 class="display-1 font-weight mb-4">Welcome to PG Box</h1>
              <h3 class="display-1 font-weight-thin mb-1">
                Air sport boxes - Administration and Participation.
              </h3>
            </v-col>
          </v-row>
          <v-divider class="d-flex justify-space-around mb-6"></v-divider>
          <v-row>
            <v-col>
              <router-link to="/help/0">
                <v-btn color="primary" rounded small>Read more...</v-btn>
              </router-link>
            </v-col>
          </v-row>
        </v-parallax>
      </v-col>

      <v-col cols="12">
        <v-row align="center" justify="center">
          <v-hover>
            <template v-slot="{ hover }">
              <v-card
                color="primary"
                dark
                white--text
                width="400px"
                :elevation="hover ? 24 : 12"
              >
                <v-card-title
                  >Get started:<v-icon right
                    >mdi-login-variant</v-icon
                  ></v-card-title
                >
                <v-divider></v-divider>
                <v-card-subtitle
                  >Register as new user, activate your account and you are ready
                  to sign in, when the "boxes" are opened.</v-card-subtitle
                >
                <v-divider class="justify-space-around mb-6"></v-divider>
                <v-row class="justify-space-around mb-2">
                  <v-btn color="primary" to="newuser" small>
                    New user
                    <v-icon right>mdi-account-plus-outline</v-icon>
                  </v-btn>
                  <router-link to="/help/2">
                    <v-btn color="primary" rounded small>Read more...</v-btn>
                  </router-link>
                </v-row>
              </v-card>
            </template>
          </v-hover>
        </v-row>
        <v-row>.</v-row>
        <v-row align="center" justify="center">
          <v-hover>
            <template v-slot="{ hover }">
              <v-card
                color="primary"
                dark
                white--text
                width="400px"
                :elevation="hover ? 24 : 6"
              >
                <v-card-title
                  >Procedure:
                  <v-icon right>mdi-format-list-numbered</v-icon></v-card-title
                >
                <v-divider></v-divider>
                <v-card-subtitle>
                  Sign in to a box, your status is set to
                  <v-chip color="red">Start</v-chip>. When landed: Change status
                  to <v-chip color="orange">Landed</v-chip>, optionally add your
                  position <v-icon small>mdi-map-marker-plus-outline</v-icon>.
                  When finished: Change status to
                  <v-chip color="green">Exit</v-chip>. At any stage, you might
                  also add a message
                  <v-icon small>mdi-message-text-outline</v-icon>.
                </v-card-subtitle>
                <v-divider class="justify-space-around mb-6"></v-divider>
                <v-row class="justify-space-around mb-2">
                  <router-link to="/help/6">
                    <v-btn color="primary" rounded small>Read more...</v-btn>
                  </router-link>
                </v-row>
              </v-card>
            </template>
          </v-hover>
        </v-row>
        <v-row>.</v-row>
        <v-row align="center" justify="center">
          <v-hover>
            <template v-slot="{ hover }">
              <v-card
                color="primary"
                dark
                white--text
                width="400px"
                :elevation="hover ? 24 : 12"
              >
                <v-card-title
                  >Responsive:
                  <v-icon right>mdi-cellphone-check</v-icon></v-card-title
                >
                <v-divider></v-divider>
                <v-card-subtitle
                  >You will certainly use this application with your
                  smart-phone. PG Box is made to be responsive to small
                  screens.</v-card-subtitle
                >
                <!-- <v-icon>mdi-cellphone-check</v-icon> -->
                <v-divider class="justify-space-around mb-6"></v-divider>
                <v-row class="justify-space-around mb-2">
                  <router-link to="/help/1">
                    <v-btn color="primary" rounded small>Read more...</v-btn>
                  </router-link>
                </v-row>
              </v-card>
            </template>
          </v-hover>
        </v-row>
      </v-col>
    </v-row>
    <v-row>.</v-row>
    <v-footer color="primary" dark>
      <v-row justify="center" no-gutters>
        <v-col class="primary dark py-4 text-center white--text" cols="6">
          {{ new Date().getFullYear() }} —
          <strong>PG Box</strong>
        </v-col>
      </v-row>
    </v-footer>
  </v-container>
</template>

<script>
// @ is an alias to /src
import sparkline from "@/components/airbox/sparkline.vue";

export default {
  name: "Home",
  data: () => ({
    items: [
      { header: "Today" },
      {
        avatar: "https://cdn.vuetifyjs.com/images/lists/1.jpg",
        title: "Get started",
        subtitle:
          "<span class='font-weight-bold'>Register</span> &mdash; Register as new user, activate your account and you are ready to check in, when the boxes are opened.",
      },
      { divider: true, inset: true },
      {
        avatar: "https://cdn.vuetifyjs.com/images/lists/2.jpg",
        title: 'Summer BBQ <span class="grey--text text--lighten-1">4</span>',
        subtitle:
          "<span class='font-weight-bold'>to Alex, Scott, Jennifer</span> &mdash; Wish I could come, but I'm out of town this weekend.",
      },
      { divider: true, inset: true },
      {
        avatar: "https://cdn.vuetifyjs.com/images/lists/3.jpg",
        title: "Oui oui",
        subtitle:
          "<span class='font-weight-bold'>Sandra Adams</span> &mdash; Do you have Paris recommendations? Have you ever been?",
      },
    ],
  }),
  components: {
    sparkline,
  },
};
</script>


